<ng-container *ngIf="!loading && pedido as p; else loadingTpl">
  <h2 mat-dialog-title class="titulo-dialogo">Pedido {{ p.orderCode }}</h2>

  <div mat-dialog-content class="contenido-dialogo">
    <!-- Info básica -->
    <div class="info-grid">
      <div class="info-row">
        <span class="label">Cliente</span>
        <span class="value">{{ p.customerName }}</span>
      </div>

      <div class="info-row">
        <span class="label">Teléfono</span>
        <span class="value">{{ p.customerPhone }}</span>
      </div>

      <div class="info-row">
        <span class="label">Tipo entrega</span>
        <span class="value">{{
          p.deliveryType === 1 ? "Retiro" : "Delivery"
        }}</span>
      </div>

      <div class="info-row" *ngIf="p.deliveryAddress">
        <span class="label">Dirección</span>
        <span class="value">{{ p.deliveryAddress }}</span>
      </div>

      <div class="info-row" *ngIf="p.deliveryNotes">
        <span class="label">Notas entrega</span>
        <span class="value">{{ p.deliveryNotes }}</span>
      </div>

      <div class="info-row">
        <span class="label">Pago</span>
        <span class="value">{{
          p.paymentMethod === 1
            ? "Efectivo"
            : p.paymentMethod === 2
              ? "Tarjeta"
              : p.paymentMethod === 3
                ? "QR"
                : "Transferencia"
        }}</span>
      </div>
    </div>

    <mat-divider style="margin: 14px 0"></mat-divider>

    <!-- Items -->
    <div class="items-container" *ngIf="p.items?.length; else sinItemsTpl">
      <div class="item-card" *ngFor="let item of p.items">
        <div class="item-header">
          <div class="item-title">{{ item.productName }}</div>
          <div class="item-cantidad">x1</div>
        </div>

        <div class="item-body">
          <div class="body-row">
            <span class="label">Precio unitario:</span>
            <span class="valor">${{ item.unitPrice }}</span>
          </div>

          <div class="body-row toppings" *ngIf="item.toppings?.length">
            <span class="label">Extras:</span>

            <div class="toppings-list">
              <div class="topping-row" *ngFor="let t of item.toppings">
                <span class="topping-name">
                  {{ t.toppingName }}
                  <small *ngIf="t.quantity > 1">x{{ t.quantity }}</small>
                </span>

                <span class="topping-price"> +${{ t.subtotal }} </span>
              </div>
            </div>
          </div>

          <div class="body-row">
            <span class="label">Subtotal:</span>
            <span class="valor subtotal">${{ item.subtotal }}</span>
          </div>

          <div class="body-row" *ngIf="item.notes">
            <span class="label">Notas:</span>
            <span class="valor nota">{{ item.notes }}</span>
          </div>
        </div>
      </div>
    </div>

    <ng-template #sinItemsTpl>
      <div class="empty-state">Este pedido no tiene items.</div>
    </ng-template>

    <mat-divider style="margin: 14px 0"></mat-divider>

    <!-- Totales -->
    <div class="total-container">
      <!-- <div class="fila">
        <span>Subtotal</span>
        <strong>${{ p.subtotalAmount }}</strong>
      </div> -->

      <div class="fila" *ngIf="p.deliveryType !== 1">
        <span>Envío</span>
        <strong>${{ p.deliveryFee }}</strong>
      </div>

      <div class="fila total-final">
        <span>Total</span>
        <strong>${{ p.totalAmount }}</strong>
      </div>
    </div>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-stroked-button mat-dialog-close>Cerrar</button>
  </div>
</ng-container>

<ng-template #loadingTpl>
  <div style="padding: 24px; text-align: center">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
</ng-template>
